/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react"
import LocationModal from "../sections/common/LocationModal"


const Location = ({ locationInfo, actionButtonText, websiteBackgroundColor, websiteTextColor, hideClassName = false, isPopupBtn = false }) => {

  const [isModalVisible, setIsModalVisible] = useState(false);

  const OpenPopup = () => {
    setIsModalVisible(true);
  }

  const onCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {isPopupBtn &&
        <>
          {/*eslint no-script-url: "off"*/}
          <a href="javascript:void(0)" onClick={OpenPopup} style={{ width: '100%', zIndex: 990, height: 60, textAlign: 'center', position: 'fixed', bottom: 0 }} className="btn-footer-popup btn-footer-brand" rel="noreferrer">
            {actionButtonText}
          </a>
        </>
      }
      {!isPopupBtn &&
        <>
          {/*eslint no-script-url: "off"*/}
          <a href="javascript:void(0)" onClick={OpenPopup} className={hideClassName ? "" : "btn-header btn-brand"} rel="noreferrer">
            {actionButtonText}
          </a>
        </>
      }
      <LocationModal
        visible={isModalVisible}
        onCancel={onCancel}
        locationInfo={locationInfo}
        actionButtonText={actionButtonText}
        websiteBackgroundColor={websiteBackgroundColor}
        websiteTextColor={websiteTextColor}
      />
    </>
  );
};

export default Location;
